import { defineListener, resourceListTag, resourceTag, type ModuleListener } from '@krp/client-runtime'

import { AQSI_TAGS } from '../../../shared/api/tags'
import { incidentsApi } from '../api/incidentsApi'
import { discrepanciesReloadRequested, incidentsReloadRequested, recoveryProofReloadRequested } from './commands'
import { incidentsRestarted } from './incidentsSlice'

/**
 * Listeners журналов: команда → перечитывание своих тегов. Состояние модуля им
 * не нужно; запросы только читают.
 */
export function createIncidentsListeners<S>(): ModuleListener<S>[] {
  return [
    // Заново — новый снимок на сервере: первая страница перечитывается, а не берётся из кэша.
    defineListener<S, ReturnType<typeof incidentsRestarted>>(incidentsRestarted.match, (action, api) => {
      const { resourceId, registerKey } = action.payload
      api.dispatch(incidentsApi.util.invalidateTags([resourceTag(AQSI_TAGS.incidents, resourceId, registerKey)]))
    }),
    defineListener<S, ReturnType<typeof incidentsReloadRequested>>(incidentsReloadRequested.match, (action, api) => {
      const { resourceId, registerKey } = action.payload
      api.dispatch(
        incidentsApi.util.invalidateTags([
          resourceListTag(AQSI_TAGS.registers, resourceId),
          ...(registerKey === null ? [] : [resourceTag(AQSI_TAGS.incidents, resourceId, registerKey)]),
        ]),
      )
    }),
    defineListener<S, ReturnType<typeof recoveryProofReloadRequested>>(recoveryProofReloadRequested.match, (action, api) => {
      const { resourceId, saleId } = action.payload
      api.dispatch(incidentsApi.util.invalidateTags([resourceTag(AQSI_TAGS.recoveryProof, resourceId, saleId)]))
    }),
    defineListener<S, ReturnType<typeof discrepanciesReloadRequested>>(discrepanciesReloadRequested.match, (action, api) => {
      api.dispatch(incidentsApi.util.invalidateTags([resourceListTag(AQSI_TAGS.discrepancies, action.payload.resourceId)]))
    }),
  ]
}
